import styled from "styled-components";
import { Container, Row } from "react-bootstrap";

export const LocationBarContainer = styled(Container)`
    box-shadow: 0 4px 10px -2px #E3E3E3;
    background-color: #FAFAFA;
    border-radius: 15px;
    width: 37vw;
    height: 100%;
    margin-bottom: 7px;
    &:hover {
        cursor: pointer;
    }
`;

export const AvailableBar1 = styled.div`
    background-color: #21BD11;
    border-radius: 50%;
    height: 15px;
    width: 15px;
    box-shadow: 0 3px 10px -2px #E3E3E3;
    margin-top: 2px;
    margin-left: 25px;
    postion: relative;
    z-index: 50;
    @media screen and (max-width: 600px) {
        width: 12px;
        height: 12px;
    }
`;

export const NotAvailableBar1 = styled.div`
    background-color: #F11F1F;
    border-radius: 50%;
    height: 15px;
    width: 15px;
    box-shadow: 0 3px 10px -2px #E3E3E3;
    margin-top: 2px;
    margin-left: 25px;
    z-index: 50;
    postion: relative;
    @media screen and (max-width: 600px) {
        width: 12px;
        height: 12px;
    }
`;

export const TemporarilyClosedBar = styled.div`
    background-color: #A86BFF;
    border-radius: 50%;
    height: 15px;
    width: 15px;
    box-shadow: 0 3px 10px -2px #E3E3E3;
    margin-top: 2px;
    margin-left: 25px;
    z-index: 50;
    postion: relative;
    @media screen and (max-width: 600px) {
        width: 12px;
        height: 12px;
    }
`;

export const LocCol = styled.div`
    text-align: center;
    font-size: 15px;
    width: 25%;
    @media screen and (max-width: 700px) {
        font-size: 8px;
        width: 15%;
        margin-left: -15px;
    }
`;

export const LocColBuildingNum = styled.div`
    text-align: center;
    font-size: 15px;
    width: 25%;
    @media screen and (max-width: 700px) {
        font-size: 8px;
        width: 15%;
        margin-left: -10px;
    }
`;

export const LocColAvailability = styled.div`
    text-align: center;
    font-size: 15px;
    width: 16%;
    @media screen and (max-width: 700px) {
        font-size: 8px;
        width: 10%;
        margin-left: -20px;
    }
`;

export const LocColPlus = styled.div`
    text-align: center;
    width: 20px;
    margin-left: -30px;
    @media screen and (max-width: 700px) {
        margin-left: -20px;
        margin-right: 20px;
    }
    @media screen and (max-width: 600px) {
        margin-left: -20px;
    }
`;

export const LocColName = styled.div`
    text-align: center;
    font-size: 11px;
    width: 50%;
    overflow: hidden;
    white-space: normal;
    
    @media screen and (min-width: 1800px) {
        font-size: 17px;
        height: 38px;
        line-height: 38px;
    }
    @media screen and (min-width: 2000px) {
        font-size: 19px;
        height: 42px;
        line-height: 42px;
    }
    @media screen and (max-width: 1700px) {
        font-size: 15px;
        height: 37px;
        line-height: 37px;
    }
    @media screen and (max-width: 1081px) {
        font-size: 11px;
        height: 39px;
        line-height: 39px;
    }
    @media screen and (max-width: 700px) {
        width: 130px;
        font-size: 8px;
        white-space: normal;
        height: 29px;
        line-height: 29px;
    }
    @media screen and (max-width: 650px) {
        width: 120px;
        height: 27px;
        line-height: 27px;
    }
    @media screen and (max-width: 600px) {
        width: 100px;
        font-size: 7px;
    }
    @media screen and (max-width: 550px) {
        width: 100px;
    }
    @media screen and (max-width: 450px) {
        width: 60px;
    }
    @media screen and (max-width: 400px) {
        width: 50px;
    }
    @media screen and (max-width: 350px) {
        width: 60px;
    }
`;

export const LocRow = styled(Row)`
    height: 40px;
    display: flex;
    align-items: center;
    &:hover {
        transition: all 0.3s ease-in-out;
        transform: scale(1.03);
    }
    margin: 10px 0 8px 0;
    position: relative;
    scroll-margin-top: 200px;
`;

export const Shadow = styled.div`
    width: 38vw;
    height: 77px;
    border-radius: 15px;
    z-index: 99;
    position: absolute;
    margin-left: -1.3%;
    margin-top: -17px;
    box-shadow: 0 0 0 10000vh rgba(0, 0, 0, .5);
`;

export const OutsideShadow = styled.div`
    width: 100vw;
    height: 1000vh;
    z-index: 100;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    background-color: 0 0 0;
`;